import React from 'react';
import { Router, Switch } from 'react-router-dom';
import history from 'utils/history';
import { axius, helper, types } from 'utils';
import { connect } from 'react-redux';
import { handleIsUserAuthenticated } from 'store/_actions/auth';
import * as Action from 'store/_actions';
// import { io } from 'socket.io-client';
import { NotificationAudio } from 'components';
// import { datadogRum } from '@datadog/browser-rum';

// ::: layouts
const Navbar = React.lazy(() => import('components/Navbar'));
const AuthRoute = React.lazy(() => import('containers/AuthRoute'));
const PrivateRoute = React.lazy(() => import('containers/PrivateRoute'));

const LogIn = React.lazy(() => import('pages/auth/LogIn'));
const DashboardPage = React.lazy(() => import('./Main'));

const App = (props) => {
	const {
		_auth: { userData },
	} = props;

	const [played, setPlayed] = React.useState(true);

	React.useEffect(() => {
		// const socket = io(helper.config.io[helper.config.env], {
		//   timeout: 20000,
		//   transports: ['websocket'],
		//   reconnection: true, // enable automatic reconnection
		//   reconnectionDelay: 1000, // start with 1 second delay
		//   reconnectionDelayMax: 5000, // max delay is 5 secs
		//   reconnectionAttempts: Infinity, // retry forever
		// });
		// socket.on('new_order', (data) => {
		//   konsole.log('new_IO_order', data);
		//   // Only play sound alert for venues user has access to
		//   if (data.merchant === 'CR' && (userData.stores || []).map(ven => ven.code).includes(data.order?.store || data.order?.store?.code)) {
		//     props.dispatch(Action.setNewOrder(data));
		//     helper.playNotificationSound(9000).then(e => {
		//       setPlayed(e);
		//     });
		//   }
		// });

		if (
			userData &&
			userData?.id &&
			userData?.roleId === types.UserRoles.CASHIER
		) {
			const sse = new EventSource(
				`${helper.config.api[helper.config.env]}/sse?key=${userData.id}`
			);
			sse.onmessage = (event) => {
				const sseOrder = helper.isJson(event.data)
					? JSON.parse(event.data)
					: {};
				// konsole.log('new_SSE_order', sseOrder);
				// Only play sound alert for venues user has access to
				if (
					sseOrder.merchant === 'CR' &&
					sseOrder.type === 'NEW_ORDER'
					// && (userData.stores || [])
					// 	.map((ven) => ven.code)
					// 	.includes(sseOrder.data?.store || sseOrder.data?.store?.code)
				) {
					props.dispatch(Action.setNewOrder(sseOrder));
					helper.playNotificationSound(9000).then((e) => {
						setPlayed(e);
					});
				}
			};
		}

		// if (userData && userData?.id) {
		// 	datadogRum.setUser({
		// 		id: userData.id,
		// 		name: userData.name,
		// 		email: userData.email,
		// 		store: (userData.stores || [])[0]?.code,
		// 	});
		// }
		// eslint-disable-next-line
	}, [userData]);

	React.useEffect(() => {
		const audio = document.getElementById('playNotificationAudio');
		if (!audio) {
			setPlayed(false);
		}
	}, []);

	React.useEffect(() => {
		if (sessionStorage.getItem('token')) {
			props.dispatch(Action.getUserData());
			props.dispatch(handleIsUserAuthenticated(true));
		} else {
			props.dispatch(handleIsUserAuthenticated(false));
		}
		// eslint-disable-next-line
	}, [sessionStorage.getItem('token')]);

	React.useEffect(() => {
		getSettings();
		setInterval(() => {
			getSettings();
		}, 600 * 1000); // 10 minutes
		// eslint-disable-next-line
	}, []);

	const getSettings = () => {
		Promise.all([axius.get('settings')]).then((res) => {
			res[0].status === 200 && helper.setStorageJson('settings', res[0].data);
			res[0].status === 200 &&
				helper.setStorageJson('permissions', res[0].data.permissions);
			res[0].status === 200 &&
				props.dispatch(
					Action.changeOutletData(
						'locations',
						res[0].data.countries.sort((a, b) => (a.name > b.name ? 1 : -1))
					)
				);
			res[0].status === 200 &&
				props.dispatch(
					Action.changeOutletData(
						'roles',
						res[0].data.roles.sort((a, b) => (a.name > b.name ? 1 : -1))
					)
				);
			// res[1].status === 200 && props.dispatch(Action.changeOutletData('plans', res[1].data.sort((a, b) => (a.name > b.name) ? 1 : -1)));
			const oldVersion = helper.versionBreak(helper.app.version);
			const newVersion = helper.versionBreak(res[0].data?.version?.desktop);
			if (!helper.isLocal && newVersion > oldVersion) {
				// konsole.log('new Version: ', res[0].data.version.desktop);
				caches.keys().then((keys) => {
					Promise.all(keys.map((key) => caches.delete(key))).then(() => {
						window.history.forward(1);
						window.location.reload(true);
					});
				});
			}
		});
	};

	return (
		<Router history={history}>
			{userData && userData.id && <Navbar />}

			<Switch>
				<AuthRoute path="/" name="login" exact component={LogIn} />
				<AuthRoute path="/admin" name="login" exact component={LogIn} />
				<PrivateRoute path="/" component={DashboardPage} />
			</Switch>

			<NotificationAudio open={!played} />
		</Router>
	);
};

function mapStateToProps(state) {
	return { _auth: state.auth };
}

export default connect(mapStateToProps)(App);
